var _ellipse, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24,
    rx: 24,
    ry: 24,
    fill: "url(#paint0_linear_17633_49788)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13C20.8174 13 17.7652 14.0531 15.5147 15.9275C13.2643 17.802 12 20.3443 12 22.9952C12.0029 24.7195 12.5413 26.4138 13.5628 27.9135C14.5843 29.4132 16.0543 30.6673 17.8298 31.5539C17.3569 32.6125 16.6477 33.6053 15.7315 34.491C17.5082 34.1791 19.176 33.5239 20.6052 32.5763C21.7071 32.8491 22.8504 32.9885 24 32.9904C27.1826 32.9904 30.2348 31.9373 32.4853 30.0628C34.7357 28.1884 36 25.6461 36 22.9952C36 20.3443 34.7357 17.802 32.4853 15.9275C30.2348 14.0531 27.1826 13 24 13Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17633_49788",
    x1: 24.381,
    y1: 44.8137,
    x2: 24.381,
    y2: 5.95702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BF675"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.e01566541df786cfa91381a88bc6deda.svg";
export { ForwardRef as ReactComponent };